export const CRM_BASE_API = '/api/dashboard/customer/crm'
export const CRM_PIPELINE_API = '/api/dashboard/customer/crm/pipelines'
